import { Box, Drawer, useMediaQuery, useTheme } from '@mui/material';
import { useState  } from 'react';
import DrawerContent from './DrawerContent';
import MobileAppBar from './MobileAppBar';

const Layout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [open, setOpen] = useState(false);

  const handleAccueilClick = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleDrawerToggle = () => {
    setMobileOpen((prevMobileOpen) => !prevMobileOpen);
  };

  const drawerSx = {
    '& .MuiDrawer-paper': {
      backgroundColor: 'black',
      boxSizing: 'border-box',
      width: isMobile ? '100%' : '240px',
      ...(isMobile && { zIndex: 1200 }),
      '@media (max-width: 600px)': {
        width: '100%',
        zIndex: '1200',
        height: 'calc(100% - 56px)',
        top: '56px',
      },
    },
  };

  return (
    <Box sx={{ display: 'flex' }}>
      {isMobile && <MobileAppBar mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />}

      <Drawer
        variant={isMobile ? 'temporary' : 'permanent'}
        open={isMobile ? mobileOpen : true}
        onClose={handleDrawerToggle}
        sx={{ ...drawerSx }}
      >
        <DrawerContent
          isMobile={isMobile}
          open={open}
          handleAccueilClick={handleAccueilClick}
          handleDrawerToggle={handleDrawerToggle}
        />
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }} />
    </Box>
  );
};

export default Layout;
